var render, staticRenderFns
import script from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedLikes.vue?vue&type=style&index=0&id=472cba64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cba64",
  null
  
)

export default component.exports